module.exports = __webpack_public_path__ + "static/media/Ravensfield-Condominium-Disclosure-Statement.fee80dab.pdf";